import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
    selector: 'tt-dispatch-planning-block-order',
    templateUrl: './dispatch-planning-block-order.component.html',
    styleUrls: ['./dispatch-planning-block-order.component.css'],
    standalone: false
})
export class DispatchPlanningBlockOrderComponent implements OnInit {
    orderInternalNo;

    public itemsListBlockOrders: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.orderInternalNo = this.stateService.getStateParams()['order_internal_no'];
    }

    private async loadBlockOrders() {
        if (!!this.orderInternalNo) {
            this.itemsListBlockOrders = await this.datatask.Post(1572, { order_internal_no: this.orderInternalNo });
        }
    }

    private async init() {
        this.loadBlockOrders();
    }

    ngOnInit() {
        this.init();
    }
}
